<ng-container [formGroup]="form">
  <ng-container [formArrayName]="formKey" *ngFor="let f of dynamicDateFormArray.controls; let i = index;">
    <ng-container [formGroupName]="i">
      <table class="width-hundred">
        <th id="order-form-driverName" class="th-display-none"></th>
        <div class="d-flex">
          <div class="row px-2 w-100 driver-truck-row" [ngClass]="{'flex-nowrap':  type == 'bulkEdit'}">
            <div class="px-1" [ngClass]="{'col-1 bulkedit-truck-dynamic truck-field-basis': type == 'bulkEdit', 'col-2': type != 'bulkEdit'}">
              <div class="carrier-text-alignment dispatch-page-field-alignment driver-truck-font">Truck #
              </div>
              <div class="dispatch-page-width" [ngClass]="{'truck-dynamic-width':  type == 'bulkEdit'}">
                <simple-control [label]="'Truck #'" [form]="f" key="truckHash" type="lookup" [items]="lookups.truckHash"
                  [required]="true" class="driver-truck-font"></simple-control>
              </div>
            </div>
            <div class="col-2 px-1" [ngClass]="{'bulkedit-truck-dynamic trucksize-field-basis':  type == 'bulkEdit'}">
              <div class="carrier-text-alignment dispatch-page-field-alignment driver-truck-font">Truck Size
              </div>
              <div class="dispatch-page-width" [ngClass]="{'driver-truck-width':  type == 'bulkEdit'}">
                <simple-control [form]="f" key="trailerSize" [label]="'Truck Size'" type="text" class="driver-truck-font">
                </simple-control>
              </div>
            </div>
            <div class="col-2 px-1" [ngClass]="{'bulkedit-truck-dynamic':  type == 'bulkEdit'}">
              <div class="carrier-text-alignment dispatch-page-field-alignment driver-truck-font">Driver Type
              </div>
              <div class="text-align-start" [ngClass]="{'bulk-driver-type':  type == 'bulkEdit'}">
                <simple-control [label]="'Driver Type'" [form]="f" key="driverType" type="lookup"
                  [items]="lookups.driverType" [required]="true" class="driver-truck-font" 
                  (onChange)="onDriverTypeChange(i, $event.value)"></simple-control>
              </div>
            </div>
            <ng-container *ngIf="carrierStatus == 1">
              <div class="col-3 px-1" [ngClass]="{'bulkedit-truck-dynamic': type == 'bulkEdit'}">
                <div class="carrier-text-alignment dispatch-page-field-alignment driver-truck-font">Driver Name</div>
                <div class="dispatch-page-width">
                  <simple-control [form]="f" key="driverName" [label]="'Driver Name'" type="text" class="driver-truck-font">
                  </simple-control>
                </div>
              </div>
              <div class="col-3 px-1" [ngClass]="{'bulkedit-truck-dynamic': type == 'bulkEdit'}">
                <div class="carrier-text-alignment dispatch-page-field-alignment driver-truck-font">Driver Phone</div>
                <div class="dispatch-page-width" [ngClass]="{'driver-phone-dynamic': type == 'bulkEdit'}">
                  <simple-control [form]="f" key="driverPhone" [label]="'Driver Phone'" type="phone" class="driver-truck-font">
                  </simple-control>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="carrierStatus != 1">
              <div class="col-3 px-1" [ngClass]="{'bulkedit-truck-dynamic': type == 'bulkEdit'}">
                <div class="carrier-text-alignment dispatch-page-field-alignment driver-truck-font">Driver Name</div>
                <div class="dispatch-page-width">
                  <ng-container *ngIf="validateCarrierDriverId(f.get('id').value); else textControl">
                    <simple-control [form]="f" key="driverId" [label]="'Driver Name'" type="lookup" [filter]="true" [filterBy]="label"
                     [items]="lookups.carriersDriver" (onChange)="onCarrierDriverSelect( i , $event.value)"
                      class="driver-truck-font">
                    </simple-control>
                     <dynamic-control-error [formControl]="f.get('driverName')" [controlName]="'Driver Name'"
                      ngDefaultControl></dynamic-control-error>
                  </ng-container>
                  <ng-template #textControl>
                    <simple-control [form]="f" key="driverName" [label]="'Driver Name'" type="text" [readonly]="true" class="driver-truck-font">
                    </simple-control>
                  </ng-template>
                </div>
              </div>
              <div class="col-3 px-1" [ngClass]="{'bulkedit-truck-dynamic': type == 'bulkEdit'}">
                <div class="carrier-text-alignment dispatch-page-field-alignment driver-truck-font">Driver Phone</div>
                <div class="dispatch-page-width" [ngClass]="{'driver-phone-dynamic': type == 'bulkEdit'}">
                  <simple-control [form]="f" key="driverPhone" [label]="'Driver Phone'" type="text"  [readonly]="true" class="driver-truck-font">
                  </simple-control>
                </div>
              </div>
            </ng-container>

          </div>
          <div class="medium medium-text pickupdetails-remove ml-0 pt-0" [ngClass]="{'mx-3 p-0':  type == 'bulkEdit'}" [ngStyle]="isDispatched ? {pointerEvents: 'none'} : ''">
            <span class="mt-1" style="float:right;" *ngIf="dynamicDateFormArray.length > noOfRequireDateFields">
              <a (click)="confirmDelete(i)" class="link-button" style="font-size: 16px; color: maroon !important">&nbsp;X</a>
            </span>
          </div>
        </div>
      </table>
    </ng-container>
  </ng-container>
</ng-container>
<ng-container *ngIf="canAddMoreDate">
  <div class="addition-date-btn" (click)="add()" [ngStyle]="isDispatched ? {pointerEvents: 'none'} : ''">
    <a class="link-button driver-truck-font">
      <span class="plus">+</span> Add Additional
    </a>
  </div>
</ng-container>

<confirm-delete-dialog
  [visible]="showDeleteWarning"
  [message]="'Are you sure you want to delete this Driver?'"
  (confirm)="onDeleteConfirm($event)">
</confirm-delete-dialog>
